/**
 * The one place a role becomes human-readable copy.
 *
 * The product term for an external contact is "reference contact", so the raw
 * REFEREE enum must never reach a user — not through a badge, not through the
 * role switcher. Anything that renders a role must go through here.
 *
 * Lives in `shared/` so both the layout chrome and the feature modules can use it:
 * `shared/` may not import from `features/`, which is why the role union is
 * re-declared here rather than imported from the auth feature.
 */
export type RoleName = 'SUPER_ADMIN' | 'ADMIN' | 'MANAGER' | 'AGENT' | 'CANDIDATE' | 'REFEREE';

export const ROLE_LABELS: Record<RoleName, string> = {
  SUPER_ADMIN: 'Super admin',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  AGENT: 'Agent',
  CANDIDATE: 'Candidate',
  REFEREE: 'Reference contact',
};

/** Display label for a role; unknown values fall back to the raw string, never blank. */
export function formatRoleLabel(role: RoleName | string): string {
  return ROLE_LABELS[role as RoleName] ?? role;
}
